import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { VideoService } from '../../../../../app/shared/API-Service/services/video.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { BaseComponent } from 'src/app/shared/components/base/base.component';




@Component({
  selector: 'app-view-video',
  templateUrl: './view-video.component.html',
  styleUrls: ['./view-video.component.css']
})
export class ViewVideoComponent extends BaseComponent implements OnInit {
  video:object [] = [];
  constructor(private _VideoService:VideoService,private _Router:Router) {super() }

  ngOnInit(): void {
    this.getvideo();
  }
  pageChanged(event: any){
    this.pageNumber = event.page;// -1 * pageSize;
    this.pager.skipCount = (this.pageNumber - 1) * this.pager.maxResultCount;
   this.getvideo();
  }

  getvideo(){
    this._VideoService.GetVideoPaged(this.pager).subscribe((res) => {
      this.video = res.data.items
      this.totalCount=res.data.totalCount 
    },(err)=>{
    },() =>{
    });
  }
  update(data){
    this._VideoService.Data.next(data);
    this._Router.navigate(['/content/admin/InsertVideo']);
    }
    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._VideoService.DeleteVideo(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getvideo();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
          })
        }
      }) 
    }
}
